import cx from 'classnames'
import React from 'react'
import Media from 'react-media'

import Banner from '@cinch/oxd-components/banner/src'
import { Bulb } from '@cinch/oxd-components/icons/src'
import IntersectionObserverWrapper from '@cinch/oxd-components/intersection-observer-wrapper/src'
import Title from '@cinch/oxd-components/page-title/src'
import Filters from '@cinch/oxd-containers/listing-filters/src'
import SearchResults from '@cinch/oxd-containers/listing-results/src'
import Layout from '@cinch/oxd-layouts/regular/src'
import { FEATURES, hasFeatureFlag } from '@cinch/oxd-utils/feature-flags/src'
import tokens from '@cinch/oxd-utils/tokens/src'

import MobileFilters from './containers/mobile-filters.container'
import SortSelect from './containers/sort-button.container'

import * as styles from './find-vehicle.module.css'

interface FindCarPageProps {
  i18n: Cinch.WebAppTranslations['findVehicle']
  initialSearchValue: string
  banner?: Cinch.WebAppTranslations['banner']
}

const FindVehiclePage: React.FC<FindCarPageProps> = ({
  i18n: { title, filters, fuelFinder, noResults, deliveryPreference, deliveryModal },
  banner,
}) => {
  const [filterSortContent, setFilterSortContent] = React.useState<React.ReactNode>(null)
  const [isMobileViewport, setIsMobile] = React.useState<boolean>(false)
  const [isFixedNav, setFixedNav] = React.useState<boolean>(false)
  const i18nFilterProps = {
    i18n: { filters, deliveryPreference, deliveryModal },
  }

  const handleIntersection = (isVisible: boolean) => {
    setFixedNav(!isVisible)
  }

  React.useEffect(() => {
    setFilterSortContent(
      <>
        {isMobileViewport && (
          <div className={styles.mobileFilters}>
            <MobileFilters
              isFixed={isFixedNav}
              data-testid="filters-mobile"
              children={<Filters {...i18nFilterProps} />}
            />
          </div>
        )}
        <div className={styles.sortSelect}>
          <SortSelect isFixed={isFixedNav} />
        </div>
      </>,
    )
  }, [isMobileViewport, isFixedNav])

  return (
    <Layout hasCompareBar={true}>
      <Media query={tokens.customMedia.m}>
        {(matches) => {
          setIsMobile(!matches)

          return null
        }}
      </Media>

      {hasFeatureFlag(FEATURES.PROMO) && banner && (
        <div data-testid="promo-banner" className={styles.bannerContainer}>
          <Media query={tokens.customMedia.m}>
            {(matches) => (
              <Banner
                roundedCorners={true}
                title={banner.title}
                subTitle={banner.subTitle}
                icon={Bulb}
                rightArrow={matches}
                href="/promo"
                tag={{
                  event: 'Click',
                  eventCategory: 'Banner',
                  eventLabel: 'Game Changer',
                  eventAction: banner.title,
                }}
              />
            )}
          </Media>
        </div>
      )}

      <Title aside={<div id="LP_DIV_1565101878463" />}>{title}</Title>

      <div data-testid="find-vehicle-body" className={styles.findVehicleBody}>
        <div className={styles.filtersColumn} data-testid="filters-desktop">
          <Media query={tokens.customMedia.m}>
            {(matches) => {
              return (
                matches && (
                  <>
                    <Filters {...i18nFilterProps} />
                  </>
                )
              )
            }}
          </Media>
        </div>

        <div className={styles.main}>
          <div className={cx(styles.header, { [styles.headerFixed]: isFixedNav })}>
            <IntersectionObserverWrapper className={styles.intersection} onIntersection={handleIntersection}>
              <div className={styles.search}></div>
            </IntersectionObserverWrapper>

            <div className={styles.filterSort}>{filterSortContent}</div>
          </div>

          <SearchResults className={styles.searchResults} i18n={{ fuelFinder, noResults }} />
        </div>
      </div>
    </Layout>
  )
}

export default FindVehiclePage
